import script from "./OverviewCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OverviewCard.vue?vue&type=script&setup=true&lang=js"

import "./OverviewCard.vue?vue&type=style&index=0&id=f6657370&lang=css"
import "./OverviewCard.vue?vue&type=style&index=1&id=f6657370&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6657370"]])

export default __exports__